import { createAction, props } from "@ngrx/store";
import { DeptLeads } from "src/app/models/dept-leads";

export const ADD_DEPARTMENT_LEADS = '[deptlead] add department leads'

export const addDeptLeads = createAction(ADD_DEPARTMENT_LEADS , props<{departmentLeads : DeptLeads[]}>());